import { Talent } from "../../Classes";

const tier7 = [
  null,
  new Talent(
    "Stormstrike",
    "spell_holy_sealofmight",
    [
      "Gives you an extra attack. In addition, increases Nature damage dealt to the target by 10%. Lasts 30 sec.",
    ],
    1,
    [[]],
    [{ x: 4, y: 1 }],
    null,
    "Melee range",
    "21% of base mana",
    "Instant",
    "16 sec cooldown",
    null,
    { isMoved: false, isChanged: true, isNew: false },
  ),
  null,
  null,
];

export default tier7;
